"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPadlock = void 0;
var React = __importStar(require("react"));
var IconPadlock = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M7,10 L7,7.584 C7,4.715 9.542,3 12,3 C14.458,3 17,4.715 17,7.584 L17,10 L7,10 Z M13.0030667,16.3061569 L13.0030667,18.2557401 C13.0030667,18.4882592 12.8743299,18.7038859 12.6485297,18.8469746 C12.4891413,18.9473354 12.1966632,19 12.0004928,19 C11.9197769,19 11.7396463,18.991057 11.6589304,18.9741645 C11.2706766,18.8877151 10.9999207,18.5836517 10.9999207,18.2338794 L10.9999207,16.2862835 C10.9999207,16.1898974 10.9345305,16.1054353 10.8354236,16.0537644 C9.97717836,15.6066123 9.74657726,14.7083333 10.2104384,13.8905418 C10.3647182,13.6182758 10.6211701,13.3847631 10.9389252,13.2357124 C11.7174762,12.8700413 12.6227207,12.9415856 13.2602743,13.3688643 C13.7302658,13.6848518 14,14.1538647 14,14.6536814 C14,15.2180868 13.7581182,15.7387706 13.184933,16.0438277 C13.0705003,16.1054353 13.0030667,16.2028151 13.0030667,16.3061569 Z M18,10 L18,7.584 C18,4.089 14.949,2 12,2 C9.051,2 6,4.089 6,7.584 L6,10 L5.465,10 C5.208,10 5,10.208 5,10.465 L5,19.358 C5,21.542 6.282,22 7.358,22 L16.642,22 C17.718,22 19,21.542 19,19.358 L19,10.465 C19,10.208 18.792,10 18.535,10 L18,10 Z" }))); };
exports.IconPadlock = IconPadlock;
exports.IconPadlock.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconPadlock;
